var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-file-upload",
    {
      staticClass: "drop-tile",
      attrs: {
        multiple: "",
        "allowed-extensions": _vm.allowedExtensions,
        "max-size": _vm.maxSize,
        disabled: _vm.sending,
      },
      on: {
        start: function ($event) {
          return _vm.onSelectStart()
        },
        input: function ($event) {
          return _vm.onFile($event)
        },
        finished: function ($event) {
          return _vm.onSelectFinished()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "tile",
          class: { busy: _vm.uploading, dragging: _vm.dragging },
          on: {
            dragenter: function ($event) {
              return _vm.onDragEnter()
            },
            dragleave: function ($event) {
              return _vm.onDragLeave()
            },
            drop: function ($event) {
              _vm.dragDepth = 0
            },
          },
        },
        [
          _vm.uploading
            ? [
                _c("div", { staticClass: "upload-title" }, [
                  _vm._v(_vm._s(_vm.uploadTitle)),
                ]),
                _c(
                  "div",
                  { staticClass: "upload-list" },
                  _vm._l(_vm.uploadJob.files, function (file, i) {
                    return _c("div", { key: i, staticClass: "upload-row" }, [
                      _c(
                        "div",
                        { staticClass: "upload-row-head" },
                        [
                          _c("w-fa", {
                            staticClass: "upload-file-icon",
                            attrs: { icon: ["far", "file"] },
                          }),
                          _c("div", { staticClass: "upload-name" }, [
                            _vm._v(_vm._s(file.name)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "upload-state", class: file.state },
                            [
                              file.state == "done"
                                ? _c("w-fa", { attrs: { icon: "check" } })
                                : [
                                    _vm._v(
                                      _vm._s(
                                        file.state == "busy"
                                          ? _vm.$ct("reading-document")
                                          : _vm.$ct("waiting")
                                      )
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "upload-bar", class: file.state },
                        [_c("div", { staticClass: "upload-bar-fill" })]
                      ),
                    ])
                  }),
                  0
                ),
                _c("div", { staticClass: "upload-footer" }, [
                  _c("div", [_vm._v(_vm._s(_vm.uploadFooter))]),
                  !_vm.sending
                    ? _c("div", { staticClass: "upload-add-more" }, [
                        _vm._v(_vm._s(_vm.$ct("add-more-files"))),
                      ])
                    : _vm._e(),
                ]),
              ]
            : _vm.dragging
            ? [
                _c(
                  "div",
                  { staticClass: "tile-circle solid" },
                  [_c("w-fa", { attrs: { icon: "upload" } })],
                  1
                ),
                _c("div", { staticClass: "tile-title" }, [
                  _vm._v(_vm._s(_vm.$ct("drop-to-upload"))),
                ]),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "tile-circle" },
                  [_c("w-fa", { attrs: { icon: "upload" } })],
                  1
                ),
                _c("div", { staticClass: "tile-title" }, [
                  _vm._v(_vm._s(_vm.$ct("drag-files-here"))),
                ]),
                _c("div", { staticClass: "tile-choose" }, [
                  _vm._v(_vm._s(_vm.$ct("or")) + " "),
                  _c("b", { staticClass: "tile-link" }, [
                    _vm._v(_vm._s(_vm.$ct("choose-a-file"))),
                  ]),
                ]),
                _c("div", { staticClass: "tile-hint" }, [
                  _vm._v(_vm._s(_vm.$ct("allowed-file-types"))),
                ]),
                _vm.showMailAddress
                  ? [
                      _c("div", { staticClass: "tile-divider" }),
                      _c("div", { staticClass: "tile-mail-label" }, [
                        _vm._v(_vm._s(_vm.$ct("or-mail-to"))),
                      ]),
                      _c("div", { staticClass: "tile-mail" }, [
                        _vm._v(_vm._s(_vm.mailAddress)),
                      ]),
                    ]
                  : _vm._e(),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }